import { MessageGroup, MessageGroupFilterInput, User, UserFilterInput } from "../../../Utilities";

export const viewerMessageGroupFilter: MessageGroupFilterInput = {
	or: [
		{
			users: [{ isCurrentEQ: true }],
		},
		{
			userGroups: [{ members: [{ isCurrentEQ: true }] }],
		},
	],
};

export function getUsersMessageGroupFilter(userIDs: User["id"][]): MessageGroupFilterInput {
	return {
		or: [
			{
				users: [{ idIn: userIDs }],
			},
			{
				userGroups: [{ members: [{ idIn: userIDs }] }],
			},
		],
	};
}

export function getMessageGroupUserFilter(messageGroupID: MessageGroup["id"]): UserFilterInput {
	return {
		or: [
			{
				messageGroups: [{ idEQ: messageGroupID }],
			},
			{
				memberGroups: [{ messageGroups: [{ idEQ: messageGroupID }] }],
			},
		],
	};
}
